// extracted by mini-css-extract-plugin
export default {"toast":"dOtioCQmQ0GJQ-umOiFccQ==","text":"zTLxet4gPke4Nn0uxTow-Q==","icon-container":"fGZDbYFcL6xQ7W4lMBO1lQ==","close":"qqY02Qt1Omzan7EP0oOkPQ==","error":"SNLIGIPFUYBQG6-Iqqj0nQ=="};